import {Component, ViewEncapsulation} from '@angular/core';
import {
  FooterComponent,
  HeaderComponent,
  INavData,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarModule,
  SidebarNavComponent,
  DropdownModule
} from "@coreui/angular";
import {OAuthEvent, OAuthService} from "angular-oauth2-oidc";
import {Router, RouterOutlet} from "@angular/router";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {AuthService} from "../../_services/auth.service"
import {navItems} from '../../_nav';
import {AsyncPipe} from "@angular/common";
import {LoadingBarModule} from "@ngx-loading-bar/core";
import { IconModule } from '@coreui/icons-angular';



@Component({
  standalone: true,
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  imports: [
    SidebarComponent,
    SidebarBrandComponent,
    SidebarNavComponent,
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    AsyncPipe,
    LoadingBarModule,
    SidebarModule,
    IconModule,
    DropdownModule
  ],
  encapsulation: ViewEncapsulation.None
})
export class NavMenuComponent {
  userName$: Observable<string>;
  public sidebarShow = true;
  public navItems: INavData[];

  constructor(private oAuthService: OAuthService, private authService: AuthService, private router: Router) {
    // this.navItems = this.authService.filterNavDataArray(navItems);
    this.navItems = navItems;

    this.oAuthService.events.subscribe((e: OAuthEvent) => {
      if (e.type === 'user_profile_loaded') {
        authService.userProfile$.pipe(map(_ => {
          // this.navItems = authService.filterNavDataArray(navItems);
          this.navItems = navItems;
        })).subscribe()
      }
    });
    this.userName$ = this.authService.userProfile$.pipe(map(x => x.username));
  }

  toggleMinimize(show: boolean) {
    this.sidebarShow = show;
  }

  async logout() {
    this.oAuthService.logOut(false);
    await this.authService.reset();
    await this.router.navigate(['/'])
  }
}
